import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import './NotFoundPage.css';

const NotFoundPage = () => {
  const { localizedPath } = useLanguage();

  useEffect(() => {
    document.title = '404 - Page Not Found | Radix Technologies';
    
    // Add meta description for 404 page
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Page not found. The requested page could not be found on Radix Technologies website.');
    }
  }, []);

  return (
    <div className="not-found-page">
      <div className="container">
        <div className="not-found-content">
          <div className="error-code">404</div>
          <h1 className="error-title">Page Not Found</h1>
          <p className="error-description">
            Sorry, the page you are looking for doesn't exist or has been moved.
          </p>
          
          <div className="error-actions">
            <Link to={localizedPath('/')} className="btn-primary">
              Go Home
            </Link>
            <Link to={localizedPath('/contact')} className="btn-secondary">
              Contact Us
            </Link>
          </div>
          
          <div className="helpful-links">
            <h3>You might be looking for:</h3>
            <ul>
              <li><Link to={localizedPath('/services')}>Our Services</Link></li>
              <li><Link to={localizedPath('/portfolio')}>Portfolio</Link></li>
              <li><Link to={localizedPath('/about')}>About Us</Link></li>
              <li><Link to={localizedPath('/careers')}>Careers</Link></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
